class TrustCards extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this._observeEntry();

    const video = this.querySelector('video');
    if (!video) return;

    this._video = video;
    this._userPaused = false;
    this._setupControls();
    this._setupVisibility();
  }

  _observeEntry() {
    if (window.innerWidth < 1024) return;

    const cards = this.querySelectorAll('[data-card]');
    cards.forEach(c => {
      c.style.opacity = '0';
      c.style.transform = 'translateY(50px)';
    });

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        cards.forEach(c => {
          const index = parseInt(c.dataset.card) || 0;
          c.animate([
            { opacity: 0, transform: 'translateY(50px)' },
            { opacity: 1, transform: 'translateY(0)' },
          ], {
            duration: 450,
            delay: index * 195,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
            fill: 'forwards',
          });
        });
        observer.disconnect();
      }
    }, { threshold: 0.15 });

    observer.observe(this);
  }

  _setupControls() {
    const v = this._video;

    const muteBtn = this.querySelector('[data-mute-toggle]');
    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        v.muted = !v.muted;
        this.querySelector('[data-icon-muted]').classList.toggle('hidden', !v.muted);
        this.querySelector('[data-icon-unmuted]').classList.toggle('hidden', v.muted);
      });
    }

    const playBtn = this.querySelector('[data-play-toggle]');
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (v.paused) {
          v.play();
          this._userPaused = false;
        } else {
          v.pause();
          this._userPaused = true;
        }
        this._updatePlayIcons();
      });
    }
  }

  _updatePlayIcons() {
    const paused = this._video.paused;
    const pauseIcon = this.querySelector('[data-icon-pause]');
    const playIcon = this.querySelector('[data-icon-play]');
    if (pauseIcon) pauseIcon.classList.toggle('hidden', paused);
    if (playIcon) playIcon.classList.toggle('hidden', !paused);
  }

  _setupVisibility() {
    const v = this._video;
    let loaded = false;

    const observer = new IntersectionObserver((entries) => {
      const visible = entries[0].isIntersecting;

      if (visible && !loaded) {
        loaded = true;
        v.querySelectorAll('source[data-src]').forEach(s => {
          s.src = s.dataset.src;
        });
        v.load();
      }

      if (loaded) {
        if (visible && !this._userPaused) {
          v.play().catch(() => {});
        } else if (!visible) {
          v.pause();
        }
        this._updatePlayIcons();
      }
    }, { rootMargin: '200% 0px', threshold: 0 });

    observer.observe(v);
  }
}

customElements.define('trust-cards', TrustCards);
